import { useQuery } from '@tanstack/react-query'
import { Link, createFileRoute } from '@tanstack/react-router'
import { ArrowLeft, Printer, ShieldAlert, ShieldCheck } from 'lucide-react'

import { DocumentoFechamento } from '@/components/fechamento/documento-fechamento'
import { Button } from '@/components/ui/button'
import { EsqueletoLinhas, EstadoVazio } from '@/components/ui/estado'
import { mensagemDeErro } from '@/lib/erros'
import { useTRPC } from '@/lib/trpc'

export const Route = createFileRoute('/gestao/fechamentos/$fechamentoId')({
  component: Fechamento,
})

/** Documento do fechamento com verificação de integridade e impressão (PDF pelo navegador). */
function Fechamento() {
  const { fechamentoId } = Route.useParams()
  const trpc = useTRPC()
  const doc = useQuery(trpc.avaliacao.fechamentos.porId.queryOptions({ id: fechamentoId }))

  return (
    <>
      <div className="nao-imprimir mb-6 flex flex-wrap items-center gap-3">
        <Link
          to="/gestao/fechamentos"
          className="inline-flex items-center gap-1 text-sm font-medium text-fg-muted hover:text-fg"
        >
          <ArrowLeft className="size-4" aria-hidden /> Fechamentos
        </Link>
        <div className="ml-auto flex items-center gap-3">
          {doc.data &&
            (doc.data.integro ? (
              <span className="inline-flex items-center gap-1 text-sm font-medium text-verde">
                <ShieldCheck className="size-4" aria-hidden /> Documento íntegro
              </span>
            ) : (
              <span
                role="alert"
                className="inline-flex items-center gap-1 text-sm font-medium text-vermelho"
              >
                <ShieldAlert className="size-4" aria-hidden /> O snapshot não confere com o hash
              </span>
            ))}
          <Button variant="secondary" size="md" onClick={() => window.print()}>
            <Printer className="size-4" aria-hidden /> Imprimir / PDF
          </Button>
        </div>
      </div>
      {doc.data ? (
        <div className="card p-8 print:border-0 print:p-0">
          <DocumentoFechamento
            resumo={doc.data.resumo}
            hash={doc.data.hash}
            cienciaEm={doc.data.cienciaEm}
          />
        </div>
      ) : doc.isError ? (
        <EstadoVazio
          tom="atencao"
          titulo="Não deu para abrir o fechamento"
          texto={mensagemDeErro(doc.error, 'Fechamento não encontrado.')}
        />
      ) : (
        <div className="card p-8">
          <EsqueletoLinhas linhas={8} rotulo="Carregando o fechamento" />
        </div>
      )}
    </>
  )
}
